import axios from 'axios';  
const {REACT_APP_USER_FEAT} = process.env

export const getUserInstance = (baseURL: string) => {
    const userAxios = axios.create({  
        baseURL: `https://${REACT_APP_USER_FEAT}.${baseURL}`, // Replace with your authenticated API base URL  
        timeout: 10000, // 10 seconds timeout  
    });  
    
    return userAxios
}
